var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-table-column-material-type"},[_vm._v("\n  "+_vm._s(_vm.getTypeName(_vm.scope.row.materialType))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }